<template>
	<div class="header" :class="type">
		<div class="header-wrapper">
			<div
				class="header-button"
				:class="action"
				@click="$emit('click')"
				v-if="!hideButton"
			></div>
			<div class="header-title">
				<slot name="title"></slot>
			</div>
			<div class="header-body" v-if="!!$slots.default">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'roundup-header',
	props: ['type', 'action', 'hideButton']
}
</script>

<style lang="scss">
.header {
	padding: 5px 0;
	.header-wrapper {
		width: 100%;
		.header-title {
			padding: 0px 25px;
			display: flex;
			text-align: center;
		}
		.header-button {
			background: url('../assets/back_white.svg') no-repeat;
			background-position: center;
			margin-top: 5px;
			width: 30px;
			height: 30px;
			margin-top: 0;
			transition: all 0.2s ease-in-out;
			cursor: pointer;
			&:hover {
				transform: scale(1.1);
			}
			&.close {
				background: url('../assets/close.svg') no-repeat;
				background-position: center;
				margin-top: 5px;
			}
			&.close-dark {
				background: url('../assets/close_gray.png') no-repeat;
				background-position: center;
				margin-top: 5px;
			}
		}
		.header-body {
			margin-bottom: 10px;
		}
	}
	&.light {
		.header-button {
			position: absolute;
			background-image: url('../assets/back_white.svg');
			left: 40px;
			background-position: center;
			margin-top: 5px;
		}
	}
	&.dark {
		.header-button {
			position: absolute;
			background-image: url('../assets/back.svg');
			left: 40px;
			background-position: center;
			margin-top: 5px;
		}
	}
}
.header .header-wrapper .header-title h1,
.header .header-wrapper .header-title h2 {
	font-weight: 600;
	font-family: 'Bitter', serif;
	-webkit-font-smoothing: antialiased;
	padding: 5px 0 20px 0;
	margin: 0;
	font-size: 24px;
	line-height: 1.2em;
	width: 100%;
	@media (max-width: 480px) {
		margin-left: 5px;
	}
}
.header.light h1,
.header.light h2,
.header.light p,
.header.light .header-body {
	color: $white;
}
.header.dark h1,
.header.dark h2,
.header.dark p {
	color: #5e6479;
}
</style>
